import styled from "styled-components";

export const Button = styled.button<{ $visible: boolean; $offsetBottom: number }>`
  position: fixed;
  right: 16px;
  bottom: ${(p) => p.$offsetBottom}px;
  z-index: 45;
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 50%;
  background: ${(p) => p.theme.tokens.gradients.button};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${(p) => p.theme.tokens.shadows.floating};
  -webkit-tap-highlight-color: transparent;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transform: translateY(${(p) => (p.$visible ? "0" : "12px")});
  pointer-events: ${(p) => (p.$visible ? "auto" : "none")};
  transition: ${(p) => p.theme.tokens.transition.fade}, transform 0.26s ease, bottom 0.2s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
